



































































































































































import {Vue, Component} from 'vue-property-decorator';

import {Setting as terms} from '@/const/terms/mainTerms';
import {ComponentTerms as compTerms} from '@/const/terms/componentTerms';
import {EditAudience as feedbackTerms} from '@/const/terms/feedback/audience';

import { ID_TYPE } from '@/const/types';
import {FormType} from './editingTypes';
import {PLATFORM} from '@/const/types';
import {PLATFORM_SELECT} from '@/const/options';

import { Form as ElForm } from 'element-ui';
import { Upload as ElUpload } from 'element-ui';
import { ElUploadInternalFileDetail } from 'element-ui/types/upload';

import Select from '@/components/ElementComponent/Select/index.vue';
import {SelectOptionType} from '@/components/ElementComponent/Select/types';
import { AxiosError, AxiosResponse } from 'axios';
import { State } from 'vuex-class';
import moment from 'moment';
import { UserState } from '@/store/user/types';

@Component<AudienceEdit>({
     name: 'AudienceEdit',
     components: {
        Select,
     },
     beforeRouteLeave (to: any, from: any, next: any) {
        if (this.isSubmit || to.name === 'login') {
            next();
        } else {
            this.$confirm(feedbackTerms.other.confirm.warnIsModified,'Warning', {
                confirmButtonText: '네',
                cancelButtonText: '아니오',
                type: 'warning'
            }).then((confirm: any) => {
                next();
            })
            .catch(() => {})
        }
    },
})
export default class AudienceEdit extends Vue {
    private terms = terms;
    private compTerms = compTerms;

    private loading: boolean = false;
    private subLoading: number = 0;
    private isSubmit: boolean = false;
    
    private postPrefix: string = '';
    private preventPostMessage: boolean = false;
    private parentWindow: Window | null = null; 

    private platformOptions: SelectOptionType[] = PLATFORM_SELECT;

    private form: FormType = {
        name: '',
        useDeepAd: false,
        deepadSegmentId: '',
        platform: PLATFORM.ANDROID,
        files: [],
    }

    @State('User') private user!: UserState;
    private DEEP_AD_COMPANY_NO = [202, 1937, 48, 3251];
    private mountDeepAudienceDialog = false;
    private deepAdAudienceFilterValue = '';
    private isDeepAdAudienceListLoading = false;
    private selectedDeepAdAudience = null;
    private deepAdAudienceList = [];
    private filteredDeepAdAudienceList = [];
    private paginatedDeepAdAudienceList = [[]];
    private currentPage = 1;

    private toggleUseDeepAd(useDeepAd) {
        this.form.useDeepAd = useDeepAd;
        
        const form = this.$refs.form as ElForm;
        form.clearValidate(useDeepAd ? 'files' : 'deepadSegmentId');
    }

    private async handleOpenDeepAdAudienceDialog() {
        this.mountDeepAudienceDialog = true;
        this.currentPage = 1;
        this.isDeepAdAudienceListLoading = true;
        
        const { data } = await this.getDeepAdAudienceList();
        const deepAdAudienceList = data.segments.map(({ gaid, idfa, update, ...rest }, idx) => {
            const size = Number(gaid) + Number(idfa);
            const [date] = update.split(' ');
            const updatedAt = moment(date);

            return { 
                ...rest,
                size,
                updatedAt,
            }
        });

        this.deepAdAudienceList = deepAdAudienceList;
        this.filteredDeepAdAudienceList = deepAdAudienceList;
        this.paginatedDeepAdAudienceList = this.getPaginatedDeepAdAudienceList(deepAdAudienceList);
        this.isDeepAdAudienceListLoading = false;
    }

    private filterDeepAdAudienceList() {
        const filteredDeepAdAudienceList = this.deepAdAudienceList.filter(({ name }) => name.toLowerCase().includes(this.deepAdAudienceFilterValue));
        this.filteredDeepAdAudienceList = filteredDeepAdAudienceList;
        this.paginatedDeepAdAudienceList = this.getPaginatedDeepAdAudienceList(filteredDeepAdAudienceList);
    }

    private handleSelectionChange(selectedDeepAdAudience) {
        if (this.mountDeepAudienceDialog) {
            this.selectedDeepAdAudience = selectedDeepAdAudience;    
            this.form.deepadSegmentId = selectedDeepAdAudience.id;

            const form = this.$refs.form as ElForm;
            form.clearValidate('deepadSegmentId');
        }
    }

    private removeSelectedDeepAdAudience() {
        this.selectedDeepAdAudience = null;
        this.form.deepadSegmentId = '';
    }

    private handleConfirmDeepAdAudienceDialog() {
        this.mountDeepAudienceDialog = false;
        this.deepAdAudienceList = [];
        this.filteredDeepAdAudienceList = [];
        this.paginatedDeepAdAudienceList = [[]];
    }

    private handleExitDeepAdAudienceDialog(done) {
        this.removeSelectedDeepAdAudience();
        this.deepAdAudienceFilterValue = '';
        done();
    }

    private getDeepAdAudienceList() {
        return this.$http.adserverAPI.post('GetDeepAdSegmentList');
    }

    private getPaginatedDeepAdAudienceList(filterDeepAdAudienceList) {
        const paginatedDeepAdAudienceList = [];

        for (let i = 0; i < Math.ceil(filterDeepAdAudienceList.length / 10); i++) {
            const paginated = [];

            for (let j = i * 10; j < Math.min(i * 10 + 10, filterDeepAdAudienceList.length); j++) {
                paginated.push(filterDeepAdAudienceList[j]);                    
            }

            paginatedDeepAdAudienceList.push(paginated);
        }

        return paginatedDeepAdAudienceList;
    }

    private numberFormatter(row) {
        const size = row.size;
        return Intl.NumberFormat().format(size);
    }

    private dateFormatter(row) {
        const updatedAt = row.updatedAt;
        return updatedAt.format('YYYY-MM-DD');
    }

    private sortDate(rowA, rowB) {
        const updatedAtA = rowA.updatedAt;
        const updatedAtB = rowB.updatedAt;
        return updatedAtA.isBefore(updatedAtB) ? -1 : updatedAtA.isAfter(updatedAtB) ? 1 : 0;
    }

    get whichLocation() {
        return this.$route.path.split('/').splice(-1, 1)[0].toLowerCase();
    }

    get isEdit() {
        return (this.$route.params && this.$route.params.audienceID && true) === true;
    }
    
    private handleChange(file: ElUploadInternalFileDetail, fileList: ElUploadInternalFileDetail[]) {
        const excelFormats = ['application/vnd.ms-excel', 'application/vnd', 'text/csv'];
        this.form.files = fileList;
        if (excelFormats.includes(file.raw.type)) {
            if (fileList.length > 1) {
                this.form.files = fileList.slice(-1);
            }
        } else {
            this.$message.error({message: '허용된 CSV 파일만 업로드 하실 수 있습니다.'});
            this.form.files.pop();
        }
    }

    private async isValidForm() {
        const form = this.$refs.form as ElForm;

        try {
            return await form.validate();
        } catch (isValid) {
            if (!isValid) {
                const errorField = (form as any).fields.find((f: any) => f.validateState === 'error') as Vue;

                if (errorField) {
                    const el = errorField.$el.querySelector('input') as HTMLElement;

                    if (el) {
                        el.focus();
                    }
                }
            }
        }
    }

    private async createAudienceMeta() {
        const form = this.form;
        const reqBody = {
            name: form.name.trim(),
            platform: form.platform,
            ...(form.useDeepAd && {
                deepad_segment_id: form.deepadSegmentId,
            })
        };

        const { data: audienceMetaData } = await this.$http.adserverAPI.post('CreateAudienceMeta', reqBody);

        if (audienceMetaData && audienceMetaData.result && audienceMetaData.audience_id) {
            return audienceMetaData.audience_id;
        } else {
            throw new Error(feedbackTerms.new.error.fail)
        }
    }

    private async uploadAudienceFile(audienceId: string) {
        const formData = new FormData();

        this.form.files.forEach((file: ElUploadInternalFileDetail) => {
            formData.append('files', file.raw);
        });

        formData.append('audience_id', audienceId)

        const { data: uploadData } = await this.$http.adserverAPI.post('UploadAudience', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        if (uploadData && uploadData.result) {
            this.handleReqSuccess();
        } else {
            throw new Error(feedbackTerms.upload.error.fail)
        }
    }

    private handleApiError(err: AxiosError) {
        if (this.parentWindow) {
            this.preventPostMessage = true;
            const parentWindow = this.parentWindow;
            parentWindow.postMessage(this.postPrefix + 'false', parentWindow.origin);
            window.close();
        }

        if (err.response && (err.response as AxiosResponse).status !== 200) {
            this.$notify.error(feedbackTerms.new.error.fail)
        } else {
            this.$notify.error(err.message)
        }
    }

    private handleReqSuccess() {
        this.$notify.success(feedbackTerms.new.success)
        this.isSubmit = true;

        if (this.parentWindow) {
            this.preventPostMessage = true;
            const parentWindow = this.parentWindow;
            parentWindow.postMessage( this.postPrefix + 'true', parentWindow.origin);
        }

        this.$router.push({name: 'audience'})
    }

    private async handleSubmitForm() {
        try {
            const validated = await this.isValidForm();

            if (validated && !this.isEdit) {
                this.loading = true;
                const audienceId = await this.createAudienceMeta();

                if (this.form.useDeepAd) {
                    this.handleReqSuccess();
                    return;
                }
                
                 await this.uploadAudienceFile(audienceId);
            }
        } catch (error) {
            this.handleApiError(error);
        } finally {
            this.loading = false;
        }
    };

    private cancelForm() {
        this.$router.push({name: 'audience'});
    }

    private created() {
        window.addEventListener('message', (e: any) => {
            if (!this.preventPostMessage && e.origin === window.origin && e.data === 'audienceNewRequest') {
                this.parentWindow = e.source as Window;
                this.postPrefix = e.data;
                this.parentWindow.postMessage(this.postPrefix + 'connected', this.parentWindow.origin);
            }
        })
    }
}
